import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosClient from "../../../utils/axiosClient";
import {
  urlInformacoes,
  urlCancelarAgendamentoUsuario,
} from "../../../utils/constants";
import MenuSide from "../../../components/usuarios/MenuSide";
import {
  IonButton,
  IonLabel,
  IonPage,
  IonContent,
  IonCard,
  IonToast,
  IonActionSheet,
} from "@ionic/react";

import HeaderApp from "../../../components/global/HeaderItem";
import StatusAgendamento from "../../../components/global/StatusAgendamento";

import moment from "moment";
import "moment/locale/pt-br";
moment().locale("pt-br");

export default function ConfirmacaoAgendamentoUsuario() {
  const [itens, setItens] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const idPage = urlParams.get("id");

  const [colorToast, setColorToast] = useState("");
  const [iconToast, setIconToast] = useState("");
  const [mensagemToast, setMensagemToast] = useState("");
  const [tempoToast, setTempoToast] = useState("");
  const [textoToast, setTextoToast] = useState("");
  const [statusToast, setStatusToast] = useState(false);

  const [actionSheetNumero, setActionSheetNumero] = useState(false);

  const consultaLista = async (url) => {
    try {
      const response = await axiosClient.post(url, {});
      return response.data[0];
    } catch (error) {
      console.log(error);
    }
  };

  const consultarItens = async () => {
    const pathname = location.pathname;

    const partesDoCaminho = pathname.split("/");
    const tipo = partesDoCaminho[1];
    const tela = "agendamentos";

    const url = urlInformacoes(tipo, tela, `id=${idPage}`);
    const lista = await consultaLista(url);
    setItens(lista);
  };

  useEffect(() => {
    consultarItens();
  }, []);

  function calcularDiferencaEmMinutos(horario1, horario2) {
    if (horario1 && horario2) {
      // Divida os horários em horas, minutos e segundos
      const [hora1, minuto1, segundo1] = horario1.split(":").map(Number);
      const [hora2, minuto2, segundo2] = horario2.split(":").map(Number);

      // Calcule a diferença em minutos
      const minutos1 = hora1 * 60 + minuto1 + segundo1 / 60;
      const minutos2 = hora2 * 60 + minuto2 + segundo2 / 60;

      // Calcule a diferença entre os minutos
      const diferencaEmMinutos = Math.abs(minutos2 - minutos1);

      return diferencaEmMinutos;
    }
  }

  const efetuarCancelamento = () => {
    axiosClient
      .post(urlCancelarAgendamentoUsuario, {
        id: idPage,
      })
      .then(() => {
        setColorToast("success");
        setIconToast("alert-outline");
        setMensagemToast(
          "Solicitação enviada com sucesso, aguarde a confirmação do cancelamento pela empresa!",
        );
        setTempoToast(2000);
        setTextoToast("Ok");
        setStatusToast(true);
        setTimeout(() => {
          navigate({ pathname: "/usuarios/agendamentos" });
        }, 3000);
      })
      .catch((erro) => {
        setColorToast("danger");
        setIconToast("alert-outline");
        setMensagemToast(
          erro.response?.data?.message ||
            "Ocorreu um erro inesperado. Tente novamente.",
        );
        setTempoToast(60000);
        setTextoToast("Ok");
        setStatusToast(true);
      });
  };

  const solicitarCancelamento = () => {
    setActionSheetNumero(true);
  };

  return (
    <IonPage id="main-content">
      <HeaderApp />
      <IonContent className="contentAgendamento">
        <IonActionSheet
          isOpen={actionSheetNumero}
          header={`Deseja realmente cancelar o agendamento?`}
          buttons={[
            {
              text: "Sim",
              role: "confirm",
              handler: () => efetuarCancelamento(),
            },
            {
              text: "Nã0",
              role: "cancel",
              handler: () => {
                return;
              },
            },
          ]}
          onDidDismiss={() => setActionSheetNumero(false)}
        ></IonActionSheet>
        <br />
        <br />
        <div className="ion-text-center">
          <h1 style={{ fontSize: 40 }}>
            {calcularDiferencaEmMinutos(
              itens.horario_inicial,
              itens.horario_final,
            )}
            <b style={{ fontSize: 15 }}>&nbsp;min</b>
          </h1>
        </div>

        <IonCard>
          <IonLabel>
            <div className="ion-padding">
              <h2>
                <i className="ri-calendar-line"></i>&nbsp;
                {moment(itens.data_agendamento).format("D")} de{" "}
                {moment(itens.data_agendamento).format("MMMM")} de{" "}
                {moment(itens.data_agendamento).format("YYYY")}
              </h2>
              <h5 style={{ marginTop: "7px", marginBottom: "5px" }}>
                <i className="ri-time-line"></i>&nbsp;
                {moment("2023-01-01 " + itens.horario_inicial).format(
                  "HH:mm",
                )}{" "}
                / {moment("2023-01-01 " + itens.horario_final).format("HH:mm")}
              </h5>
              <h5>
                <i className="ri-store-2-line"></i>&nbsp; Serviço:{" "}
                {itens.servico}
              </h5>
              {itens.status && (
                <h5 style={{ marginTop: "7px", marginBottom: "5px" }}>
                  <StatusAgendamento
                    status={itens.status}
                    data={itens.data_agendamento}
                  />
                </h5>
              )}
            </div>
          </IonLabel>
        </IonCard>

        <IonCard>
          <IonLabel color={'danger'}>
            <h1
              style={{
                textAlign: "center",
                justifyContent: "center",
                fontWeight: "900",
              }}
            >
              Seu Agendamento acima foi confirmado com sucesso.
            </h1>
            <h1
              style={{
                textAlign: "center",
                justifyContent: "center",
                fontWeight: "900",
              }}
            >
              Não esqueça de comparecer no local na data e horário marcado!
            </h1>
          </IonLabel>
        </IonCard>
      </IonContent>
      <MenuSide />
    </IonPage>
  );
}
